export class SeqLoggingTokenService {
    private tokenPromise: Promise<string>;
    constructor() {
        console.info(`Logging errors. @see seq_error_logger.ts`)
        this.fetchToken();
    }
    fetchToken() {
        const promise = new Promise<any>((resolve, reject) => {
            fetch('/SeqLogging/token')
                .then(res => res.json())
                .then(json => resolve(json.token))
        });
        this.tokenPromise = promise;
    }
    getToken(): Promise<string> {
        return this.tokenPromise;
    }
}
